import Format from "./format"

const FormatCounter = (value) => {
  return Format(value, true, 2)
}

export default FormatCounter